module.exports = __webpack_public_path__ + "static/media/mcloudy_n.5e3f9c75.svg";